<template>
  <d-container class="layout-default" fluid>
    <d-row>

      <aside class="main-sidebar col-12 col-md-3 col-lg-2 px-0" :class="[sidebar.visible ? 'open' : '']">

        <div class="main-navbar">
          <nav class="navbar align-items-stretch navbar-light bg-white flex-md-nowrap border-bottom p-0">
            <router-link to="/" class="navbar-brand w-100 mr-0">
              <div class="d-table m-auto" @click="onShowNavigation">
                <span class="d-md-inline ml-1">ROOSH<span class="orange">.</span></span>
              </div>
            </router-link>

            <a class="toggle-sidebar d-sm-inline d-md-none" @click="onHideNavigation">
              <i class="material-icons">&#xE5C4;</i>
            </a>
          </nav>
        </div>

        <div class="nav-wrapper">
          <d-nav class="flex-column">
            <li v-for="(item, navItemIdx) in sidebar.items" :key="navItemIdx" class="nav-item dropdown" @click="onCheckMediaQuery">
              <d-link class="nav-link" :class="[item.items && item.items.length ? 'dropdown-toggle' : '']" :to="item.to" v-d-toggle="`snc-${navItemIdx}`" :exact="true">
                <div class="item-icon-wrapper" v-if="item.before" v-html="item.before" />
                <span v-if="item.title">{{ item.title }}</span>
                <div class="item-icon-wrapper" v-if="item.after" v-html="item.after" />
              </d-link>

              <d-collapse v-if="item.items && item.items.length" :id="`snc-${navItemIdx}`" class="dropdown-menu dropdown-menu-small" accordion="sidebar-items-accordion">
                <d-dropdown-item v-for="(subItem, subItemIdx) in item.items" :key="subItemIdx" :href="subItem.href" :to="subItem.to">
                  {{ subItem.title }}
                </d-dropdown-item>
              </d-collapse>
            </li>
          </d-nav>
        </div>
      </aside>

      <d-col class="main-content offset-lg-2 offset-md-3 p-0" lg="10" md="9" sm="12" tag="main">
        <navbar :sidebar="sidebar"/>
        <slot />
      </d-col>

    </d-row>
  </d-container>
</template>

<script>
import Navbar from '@/components/common/Navbar';

export default {
  name: 'layout-default',
  components: { Navbar },
  data: function () {
    return {
      sidebar: {
        visible: false,
        items: require('@/router/navbar').default,
      },
    };
  },
  methods: {
    onHideNavigation: function () {
      this.sidebar.visible = false;
    },

    onShowNavigation: function () {
      this.sidebar.visible = true;
    },

    onCheckMediaQuery: function () {
      let mql = window.matchMedia('(max-width: 768px)');
      if(mql) this.sidebar.visible = false
    },
  }
};
</script>
